export const TestMatchResult = {
  homeTeamPlayers: [
    {
      playerName: "OhterHome1",
      sex: "Male",
      isForeign: true,
    },
    {
      playerName: "OhterHome2",
      sex: "Male",
      isForeign: true,
    },
    {
      playerName: "OhterHome3",
      sex: "Female",
      isForeign: false,
    },
    {
      playerName: "OhterHome4",
      sex: "Female",
      isForeign: false,
    },
    {
      playerName: "OhterHome5",
      sex: "Female",
      isForeign: false,
    },
  ],
  awayTeamPlayers: [
    {
      playerName: "OhterAway1",
      sex: "Male",
      isForeign: true,
    },
    {
      playerName: "OhterAway2",
      sex: "Male",
      isForeign: true,
    },
    {
      playerName: "OhterAway3",
      sex: "Female",
      isForeign: false,
    },
    {
      playerName: "OhterAway4",
      sex: "Female",
      isForeign: false,
    },
    {
      playerName: "OhterAway5",
      sex: "Female",
      isForeign: false,
    },
  ],
  gameResults: [
    {
      gameNumber: 1,
      homeSetResult: 0,
      awaySetResult: 0,
      homePlayerName: "OhterHome1",
      awayPlayerName: "OhterAway1",
      setResults: [
        {
          setNumber: 1,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 2,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 3,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 4,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 5,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
      ],
    },
    {
      gameNumber: 2,
      homeSetResult: 0,
      awaySetResult: 0,
      homePlayerName: "OhterHome2",
      awayPlayerName: "OhterAway2",
      setResults: [
        {
          setNumber: 1,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 2,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 3,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 4,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 5,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
      ],
    },
    {
      gameNumber: 3,
      homeSetResult: 0,
      awaySetResult: 0,
      homePlayerName: "OhterHome3",
      awayPlayerName: "OhterAway3",
      setResults: [
        {
          setNumber: 1,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 2,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 3,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 4,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 5,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
      ],
    },
    {
      gameNumber: 4,
      homeSetResult: 0,
      awaySetResult: 0,
      homePlayerName: "OhterHome4",
      awayPlayerName: "OhterAway4",
      setResults: [
        {
          setNumber: 1,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 2,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 3,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 4,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 5,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
      ],
    },
    {
      gameNumber: 5,
      homeSetResult: 0,
      awaySetResult: 0,
      homePlayerName: "OhterHome5",
      awayPlayerName: "OhterAway5",
      setResults: [
        {
          setNumber: 1,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 2,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 3,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 4,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
        {
          setNumber: 5,
          homePlayerScore: 0,
          awayPlayerScore: 0,
        },
      ],
    },
  ],
  homePlayerPoint: 0,
  awayPlayerPoint: 0,
  awayTotalPoints: 0,
  homeAdditionalPoint: 0,
  awayAdditionalPoint: 0,
  homeTotalPoints: 0,
};

export default { TestMatchResult };
